// Intentional 80px travel past the minimum before collapse: the sidebar holds
// at its minimum while the pointer continues inward, so hitting the resize
// boundary does not immediately dismiss it. Reopening still requires reaching
// the minimum itself. Keep this generous buffer distinct from pointer jitter.
const SIDEBAR_COLLAPSE_OVERSHOOT = 80;

/** Keep normal resizing stable; require a deliberate pull beyond the minimum. */
export function sidebarDragAction(
  open: boolean,
  startWidth: number,
  delta: number,
  minWidth: number,
): "collapse" | "expand" | "resize" {
  if (!open) return startWidth + delta >= minWidth ? "expand" : "resize";
  return delta < 0 && startWidth + delta <= minWidth - SIDEBAR_COLLAPSE_OVERSHOOT
    ? "collapse"
    : "resize";
}
